module.exports = __webpack_public_path__ + "img/icon1@2x.55422764.png";